<template>
    <div class="product-section" :class="$vuetify.breakpoint.smAndDown ? 'pb-2rem' : ''">
        <product-filter-bar></product-filter-bar>
        <v-container :fluid="$vuetify.breakpoint.mdAndDown">
            <v-row class="mt-6" v-if="!productsLoading">
                <v-col cols="12" class="text-center" v-if="sortedProducts.length === 0">
                    No products found. Please refine your search.
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    xl="3"
                    v-for="product in sortedProducts"
                    :key="product.name"
                    class="mb-1"
                >
                    <v-lazy>
                        <product-overview-card
                            :product="product"
                            @click="activeProduct = product; showDetails = true"
                        ></product-overview-card>
                    </v-lazy>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    xl="3"
                    v-for="n in 50"
                    :key="n"
                    class="mb-1"
                >
                    <v-lazy>
                        <v-card>
                            <v-skeleton-loader
                                type="card"
                            >
                            </v-skeleton-loader>
                            <v-card-text>
                                <v-skeleton-loader
                                    type="paragraph"
                                >
                                </v-skeleton-loader>
                                <v-skeleton-loader
                                    type="avatar"
                                >
                                </v-skeleton-loader>
                            </v-card-text>
                            <v-skeleton-loader
                                type="actions"
                            >
                            </v-skeleton-loader>
                        </v-card>

                    </v-lazy>
                </v-col>
            </v-row>
        </v-container>
        <product-details-card
            v-model="showDetails"
            @clickout="showDetails = false"
            :product="activeProduct"
        ></product-details-card>
    </div>
</template>

<script>
    import ProductFilterBar from "../components/products/ProductFilterBar";
    import ProductOverviewCard from "../components/products/ProductOverviewCard";
    import ProductDetailsCard from "../components/products/ProductDetailsCard";
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import {sortBy} from "../utils/sort";

    export default {
        name: "Products",
        components: {
            ProductFilterBar, ProductOverviewCard, ProductDetailsCard
        },
        data(){
            return {
                showDetails: false,
                activeProduct: {}
            }
        },
        computed: {
            ...mapState([
                'products', 'productSort', "productCategoryFilter", "productAttributeFilter",
                "productSearchText"
            ]),
            ...mapGetters(["productsLoading"]),
            sortFunc(){
                let funcArgs;
                switch (this.productSort) {
                    case 'A-Z':
                        funcArgs = 'name';
                        break;
                    case 'Z-A':
                        funcArgs = {name: 'name', reverse: true};
                        break;
                    case 'Price: High to Low':
                        funcArgs = {name: 'price', reverse: true};
                        break;
                    case 'Price: Low to High':
                        funcArgs = 'price';
                        break;
                }

                return sortBy(funcArgs)

            },
            filteredProducts(){
                let products = this.products.map(x=>x);

                // Category Filter
                if(this.productCategoryFilter.length > 0){
                    products = products.filter(product => this.productCategoryFilter.some(item => product.display_categories.includes(item)))
                }


                // Attribute filter
                if(this.productAttributeFilter.length > 0){
                    products = products.filter(product => {

                        let intersect = product.attributes.filter(attribute => this.productAttributeFilter.includes(attribute.name));
                        return intersect.length > 0
                    })
                }


                // Search text filter
                if(this.productSearchText.length > 0){
                    products = products.filter(product => {
                        let nameMatches = product.name.toLowerCase().includes(this.productSearchText.toLowerCase());
                        let shortDescMatches = product.short_desc.toLowerCase().includes(this.productSearchText.toLowerCase());
                        let longDescMatches = product.long_desc.toLowerCase().includes(this.productSearchText.toLowerCase());
                        return nameMatches || shortDescMatches || longDescMatches
                    })
                }

                return products

            },
            sortedProducts(){
                let processedProducts = this.filteredProducts.map(x => x);
                processedProducts.forEach(x => {x.price = parseFloat(x.price)});
                return processedProducts.sort(this.sortFunc)
            }
        },
        methods: {
            ...mapMutations(["setProductSearchText", "setProductCategoryFilter", "setProductAttributeFilter"]),
        },
        beforeRouteLeave(to, from, next) {
            this.setProductSearchText('')
            this.setProductCategoryFilter([])
            this.setProductAttributeFilter([])
            next()
        }
    }
</script>

<style scoped>
.product-section{
    background-image: radial-gradient(rgba(149,60,99, .1) 20%, transparent 20%), radial-gradient(rgba(149,60,99, .1) 20%, transparent 20%);
    background-color: white;
    background-position: 0 0, 50px 50px;
    background-size: 100px 100px;
    background-repeat: repeat;
    min-height: 60rem;
    width: 100%;
}

.pb-2rem{
    padding-bottom: 2rem;
}
</style>